exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._39NB3aTivewkqd img{height:140px;width:280px;border-radius:3px}._39NB3aTivewkqd p{text-align:center;font-size:14px;line-height:20px;color:#5e6c84;padding-bottom:8px}.tgKieSz3YDD6s-{padding-top:15px;font-size:16px;line-height:20px;text-align:center;color:#000}._3SvvsS-c9gw_yG{margin-bottom:0;border-radius:3px}", ""]);

// exports
exports.locals = {
	"workspacesPreambleBoardHeaderButtonIntro": "_39NB3aTivewkqd",
	"workspacesPreambleBoardHeaderButtonIntroTitle": "tgKieSz3YDD6s-",
	"workspacesPreambleBoardHeaderButtonContinueButton": "_3SvvsS-c9gw_yG"
};